const methods = {
  $id(id: string = ""): string {
    // @ts-ignore
    return `${this.uid}-${id}`;
  },

  random(): string {
    return Math.random().toString(36).substring(2, 7);
  },
};

export default function install(Vue: any) {
  const uidProperty = "uid";

  let uidCounter = 0;
  Vue.mixin({
    beforeCreate() {
      uidCounter += 1;
      const uid = `uid-${uidCounter}-${methods.random()}`;
      Object.defineProperties(this, {
        [uidProperty]: {
          get() {
            return uid;
          },
        },
      });
    },
  });

  Vue.prototype.$id = methods.$id;
}
